import { render, staticRenderFns } from "./AnnounceHistory.vue?vue&type=template&id=c9b25530&scoped=true&"
import script from "./AnnounceHistory.vue?vue&type=script&lang=js&"
export * from "./AnnounceHistory.vue?vue&type=script&lang=js&"
import style0 from "./AnnounceHistory.vue?vue&type=style&index=0&id=c9b25530&prod&lang=css&"
import style1 from "./AnnounceHistory.vue?vue&type=style&index=1&id=c9b25530&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b25530",
  null
  
)

export default component.exports